export enum SnapshotAsset {
  QCAD = 'QCAD',
  QCAD_TEST = 'QCAD_TEST'
}

// Shape returned by GET /snapshots - a time-series of wallet balance snapshots
export interface SnapshotModel {
  id?: string
  createdAt?: string
  blockchainDetailsId: string
  balance: string
  asset: SnapshotAsset
  consolidationDate: string
  rate?: number
  dailyRevenue?: number
  walletName?: string
  walletAddress?: string
  walletChain?: string
  walletType?: string
}
